import add from './add'
import asap from './asap'
import basicInfo from './basic-information'
import edit from './edit'
import notes from './notes'
import transactions from './transactions'
import actionLogs from './action-logs'
import dispatchLogs from './dispatch-logs'
import charter from './charter'
import optin from './optin'
import mtech from './mtech'
import stripe from './stripe'
import lyft from './lyft'

let sharedMutations = []
sharedMutations = sharedMutations.concat(basicInfo.sharedMutations)
sharedMutations = sharedMutations.concat(edit.sharedMutations)
sharedMutations = sharedMutations.concat(notes.sharedMutations)
sharedMutations = sharedMutations.concat(transactions.sharedMutations)
sharedMutations = sharedMutations.concat(actionLogs.sharedMutations)
sharedMutations = sharedMutations.concat(dispatchLogs.sharedMutations)

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    add.state,
    asap.state,
    basicInfo.state,
    edit.state,
    notes.state,
    transactions.state,
    actionLogs.state,
    dispatchLogs.state,
    charter.state,
    optin.state,
    mtech.state,
    stripe.state,
    lyft.state,
  ),
  mutations: Object.assign(
    add.mutations,
    asap.mutations,
    basicInfo.mutations,
    edit.mutations,
    notes.mutations,
    transactions.mutations,
    actionLogs.mutations,
    dispatchLogs.mutations,
    charter.mutations,
    optin.mutations,
    mtech.mutations,
    stripe.mutations,
    lyft.mutations,
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/index.js